import React, { useEffect, useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Routes } from '../../../../utils';
import NavBarItem from './NavBarItem';
import NavBarItemWithOverlay from './NavBarItemWithOverlay';
import NavBarDropdown from './NavBarDropdown';
import SandboxLogo from '../../../../assets/SandBoxSystem.png';
import { useAuthContext } from '../../../Auth/AuthProvider';
import { PermissionEnum } from '../../../../types/PermissionEnum';
import './NavBar.scss';

export const NavBar = (): React.ReactElement => {
    const [selectedTab, setSelectedTab] = useState<any>(window.location.pathname);
    const isSystemAdminActive: boolean =
        selectedTab === `${Routes.SYSTEM_ADMIN_USERS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_PERMISSIONS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_CUSTOMERS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_CUSTOMER_PARENTS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_CREWS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_LOFAS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_PROPANTS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_DRIVERS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_CARRIERS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_PROPANTS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_SETTINGS.route}` ||
        selectedTab === `${Routes.SYSTEM_ADMIN_YARDS.route}`;
    const isReportingActive: boolean = selectedTab === `${Routes.DRIVER_REPORT.route}`;
    const isProfileActive: boolean =
        selectedTab === `${Routes.PROFILE.route}` || selectedTab === `${Routes.CHANGE_PASSWORD.route}`;
    const profileHeader = (
        <div className="NavBar-ProfileIconContainer">
            <i className="material-icons NavBar-ProfileIcon">person</i>
        </div>
    );
    var authContext = useAuthContext();
    const canViewUsers = authContext.userHasPermission(PermissionEnum.ViewUsers);
    const canViewPermissions = authContext.userHasPermission(PermissionEnum.ViewPermissions);
    const canViewLofas = authContext.userHasPermission(PermissionEnum.ViewLOFA);
    const canViewCustomers = authContext.userHasPermission(PermissionEnum.ViewCustomer);
    const canViewCrews = authContext.userHasPermission(PermissionEnum.ViewCrew);
    const canViewProppants = authContext.userHasPermission(PermissionEnum.ViewProppant);
    const canViewDrivers = authContext.userHasPermission(PermissionEnum.ViewDriver);
    const canViewCustomerParent = authContext.userHasPermission(PermissionEnum.ViewCustomerParent);
    const canViewCarriers = authContext.userHasPermission(PermissionEnum.ViewDriverCompany);
    const canViewSetting = authContext.userHasPermission(PermissionEnum.ViewSettings);
    const canViewYards = authContext.userHasPermission(PermissionEnum.ViewYard);

    const isAdmin =
        canViewUsers ||
        canViewPermissions ||
        canViewCustomers ||
        canViewLofas ||
        canViewCrews ||
        canViewProppants ||
        canViewCustomerParent ||
        canViewCarriers ||
        canViewSetting ||
        canViewDrivers;
    const canViewJob = authContext.userHasPermission(PermissionEnum.ViewJob);
    const canEditJob = authContext.userHasPermission(PermissionEnum.EditJob);
    const canViewMessages = authContext.userHasPermission(PermissionEnum.ViewMessages);

    const [toggleButton, setToggleButton] = useState(false);

    useEffect(() => {
        setToggleButton(false);
    }, [selectedTab]);

    return (
        <Navbar
            expand="lg"
            className="NavBar-Container"
            onSelect={(eventKey: string | null): void => {
                setSelectedTab(eventKey);
            }}
        >
            <Navbar.Brand href={Routes.HOME.route}>
                <img alt="" src={SandboxLogo} className="d-inline-block align-top" />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setToggleButton(!toggleButton)} />

            <div className="NavBar-Items-Container">
                <Nav className="mr-auto NavBar-linksContainer">
                    <NavBarItem
                        href={Routes.DASHBOARD.route}
                        title="Dashboard"
                        isActive={selectedTab === Routes.DASHBOARD.route}
                        isDisabled={false}
                    />
                    <NavBarItem
                        href={Routes.JOB_MANAGEMENT.route}
                        title="Job Management"
                        isActive={
                            selectedTab === Routes.JOB_MANAGEMENT.route ||
                            selectedTab.startsWith(Routes.JOB_PROFILE.route) ||
                            selectedTab.startsWith(Routes.JOB_LOADS.route) ||
                            selectedTab.startsWith(Routes.JOB_MANAGEMENT_FOR_TAB.route)
                        }
                        isDisabled={!(canViewJob || canEditJob)}
                    />
                    <NavBarItem
                        href={Routes.LOAD_MANAGEMENT.route}
                        title="Load Management"
                        isActive={
                            selectedTab === Routes.LOAD_MANAGEMENT.route ||
                            selectedTab.startsWith(Routes.LOAD_PROFILE.route) ||
                            selectedTab.startsWith(Routes.LOAD_HISTORY.route)
                        }
                        isDisabled={!authContext.userHasPermission(PermissionEnum.ViewLoads)}
                    />
                    <NavBarItem
                        href={Routes.EQUIPMENT_MANAGEMENT.route}
                        title="Equipment Management"
                        isActive={
                            selectedTab.startsWith(Routes.EQUIPMENT_MANAGEMENT.route) ||
                            selectedTab.startsWith(Routes.EQUIPMENT_HISTORY.route) ||
                            selectedTab.startsWith(Routes.EDIT_ASSET_LOAD.route)
                        }
                        isDisabled={!authContext.userHasPermission(PermissionEnum.ViewAssetLoads)}
                    />
                    <NavBarItem
                        href={Routes.MESSAGES.route}
                        title="Messages"
                        isActive={
                            selectedTab === Routes.MESSAGES.route ||
                            selectedTab.startsWith(Routes.MESSAGES_CREATE.route) ||
                            selectedTab.startsWith(Routes.MESSAGES_WITH_DRIVER_ID.route) ||
                            selectedTab.startsWith(Routes.MESSAGES_WITH_ID.route)
                        }
                        isDisabled={!authContext.userHasPermission(PermissionEnum.ViewMessages)}
                    />
                    <NavBarDropdown
                        title="Reporting"
                        isActive={isReportingActive}
                        // routes={[Routes.DRIVER_REPORT, Routes.POWER_BI_REPORT]}
                        routes={[
                            Routes.POWER_BI_REPORT,
                            {
                                title: 'Sandbox Reporting',
                                type: 'external',
                                route:
                                    'https://app.powerbi.com/groups/me/apps/0cd3ab7f-50a5-4e39-82da-edeec28d4c4a/reports/03305737-310c-4198-a249-3a5aa2202d58/ReportSectionc4e11989ce20a4919ca0',
                            },
                        ]}
                    />

                    {isAdmin && (
                        <NavBarDropdown
                            title={Routes.SYSTEM_ADMIN.title}
                            isActive={isSystemAdminActive}
                            routes={[
                                Routes.SYSTEM_ADMIN_USERS,
                                Routes.SYSTEM_ADMIN_PERMISSIONS,
                                Routes.SYSTEM_ADMIN_LOFAS,
                                Routes.SYSTEM_ADMIN_CUSTOMERS,
                                Routes.SYSTEM_ADMIN_CUSTOMER_PARENTS,
                                Routes.SYSTEM_ADMIN_DRIVERS,
                                Routes.SYSTEM_ADMIN_CARRIERS,
                                Routes.SYSTEM_ADMIN_PROPANTS,
                                Routes.SYSTEM_ADMIN_CREWS,
                                Routes.SYSTEM_ADMIN_SETTINGS,
                                Routes.SYSTEM_ADMIN_YARDS,
                            ]}
                        />
                    )}
                </Nav>
                <Nav>
                    <NavBarItemWithOverlay>
                        <Nav.Link href={Routes.EMAIL.route} disabled>
                            <i className="material-icons NavBar-NotificationIcon">email</i>
                        </Nav.Link>
                    </NavBarItemWithOverlay>
                    <NavBarDropdown
                        header={profileHeader}
                        isActive={isProfileActive}
                        routes={[Routes.PROFILE, Routes.CHANGE_PASSWORD, Routes.HOME]}
                    />
                </Nav>
            </div>

            {toggleButton && (
                <div className="Collapsed-NavBar">
                    <Nav className="NavBar-linksContainer-Expanded">
                        <NavBarItem
                            href={Routes.DASHBOARD.route}
                            title="Dashboard"
                            isActive={selectedTab === Routes.DASHBOARD.route}
                            isDisabled={false}
                        />
                        {window.screen.width > 1199 ? (
                            <NavBarItem
                                href={Routes.JOB_MANAGEMENT.route}
                                title="Job Management"
                                isActive={
                                    selectedTab === Routes.JOB_MANAGEMENT.route ||
                                    selectedTab.startsWith(Routes.JOB_PROFILE.route) ||
                                    selectedTab.startsWith(Routes.JOB_LOADS.route) ||
                                    selectedTab.startsWith(Routes.JOB_MANAGEMENT_FOR_TAB.route)
                                }
                                isDisabled={!(canViewJob || canEditJob)}
                            />
                        ) : (
                            <NavBarItem
                                href={Routes.JOB_MANAGEMENT_FOR_TAB.route}
                                title="Job Management"
                                isActive={
                                    selectedTab === Routes.JOB_MANAGEMENT.route ||
                                    selectedTab.startsWith(Routes.JOB_PROFILE.route) ||
                                    selectedTab.startsWith(Routes.JOB_LOADS.route) ||
                                    selectedTab.startsWith(Routes.JOB_MANAGEMENT_FOR_TAB.route)
                                }
                                isDisabled={!(canViewJob || canEditJob)}
                            />
                        )}
                        <NavBarItem
                            href={Routes.LOAD_MANAGEMENT.route}
                            title="Load Management"
                            isActive={
                                selectedTab === Routes.LOAD_MANAGEMENT.route ||
                                selectedTab.startsWith(Routes.LOAD_PROFILE.route) ||
                                selectedTab.startsWith(Routes.LOAD_HISTORY.route)
                            }
                            isDisabled={!authContext.userHasPermission(PermissionEnum.ViewLoads)}
                        />
                        <NavBarItem
                            href={Routes.EQUIPMENT_MANAGEMENT.route}
                            title="Equipment Management"
                            isActive={
                                selectedTab.startsWith(Routes.EQUIPMENT_MANAGEMENT.route) ||
                                selectedTab.startsWith(Routes.EQUIPMENT_HISTORY.route) ||
                                selectedTab.startsWith(Routes.EDIT_ASSET_LOAD.route)
                            }
                            isDisabled={!authContext.userHasPermission(PermissionEnum.ViewLoads)}
                        />
                        <NavBarItem
                            href={Routes.MESSAGES.route}
                            title="Messages"
                            isActive={
                                selectedTab === Routes.MESSAGES.route ||
                                selectedTab.startsWith(Routes.MESSAGES_CREATE.route) ||
                                selectedTab.startsWith(Routes.MESSAGES_WITH_DRIVER_ID.route) ||
                                selectedTab.startsWith(Routes.MESSAGES_WITH_ID.route)
                            }
                            isDisabled={!authContext.userHasPermission(PermissionEnum.ViewMessages)}
                        />

                        <NavBarDropdown
                            title="Reporting"
                            isActive={isReportingActive}
                            // routes={[Routes.DRIVER_REPORT, Routes.POWER_BI_REPORT]}
                            routes={[
                                Routes.POWER_BI_REPORT,
                                {
                                    title: 'Sandbox Reporting',
                                    type: 'external',
                                    route:
                                        'https://app.powerbi.com/groups/me/apps/0cd3ab7f-50a5-4e39-82da-edeec28d4c4a/reports/03305737-310c-4198-a249-3a5aa2202d58/ReportSectionc4e11989ce20a4919ca0',
                                },
                            ]}
                        />

                        {isAdmin && (
                            <NavBarDropdown
                                title={Routes.SYSTEM_ADMIN.title}
                                isActive={isSystemAdminActive}
                                routes={[
                                    Routes.SYSTEM_ADMIN_USERS,
                                    Routes.SYSTEM_ADMIN_PERMISSIONS,
                                    Routes.SYSTEM_ADMIN_LOFAS,
                                    Routes.SYSTEM_ADMIN_CUSTOMERS,
                                    Routes.SYSTEM_ADMIN_CUSTOMER_PARENTS,
                                    Routes.SYSTEM_ADMIN_DRIVERS,
                                    Routes.SYSTEM_ADMIN_CARRIERS,
                                    Routes.SYSTEM_ADMIN_PROPANTS,
                                    Routes.SYSTEM_ADMIN_CREWS,
                                    Routes.SYSTEM_ADMIN_SETTINGS,
                                    Routes.SYSTEM_ADMIN_YARDS,
                                ]}
                            />
                        )}

                        <Nav.Link
                            href={Routes.EMAIL.route}
                            disabled
                            className="NavBar-NotificationIcon-Container NavBar-TabIndicator"
                        >
                            <i className="material-icons NavBar-NotificationIcon">email</i>
                        </Nav.Link>

                        <NavBarDropdown
                            header={profileHeader}
                            isActive={isProfileActive}
                            routes={[Routes.PROFILE, Routes.CHANGE_PASSWORD, Routes.HOME]}
                        />
                    </Nav>
                </div>
            )}
        </Navbar>
    );
};

export default NavBar;

